import { UPLOAD_IMAGE_TO_S3, RESET_UPLOAD_IMAGE_TO_S3, UPLOAD_YELP_IMAGE_TO_S3, RESET_UPLOAD_YELP_IMAGE_TO_S3 } from "../actions/image";

const initialState = {
    url: null
};

export default function imageReducer(state = initialState, action) {
    switch (action.type) {
        case UPLOAD_IMAGE_TO_S3:
            return {
                ...state,
                url: action.payload.url,
                error: action.error
            };
        case RESET_UPLOAD_IMAGE_TO_S3:
            return {
                ...state,
                url: state.url
            };
        case UPLOAD_YELP_IMAGE_TO_S3:
            return {
                ...state,
                url: action.payload.url,
                error: action.error
            };
        case RESET_UPLOAD_YELP_IMAGE_TO_S3:
            return {
                ...state,
                url: state.url
            };
        default:
            return state;
    }
}